<template>
  <div class="px-16">
    <c-label :color="$theme.COLOR.UI.UI13" :weight="500" :size="16" :lineHeight="16"
      >{{ $t('title.eventMap') }}
    </c-label>
    <div class="content-wrapper">
      <div class="area">
        <ConfigTitle required class="title"
          >{{ $util.capitalize($t('label.widgetName')) }}
        </ConfigTitle>
        <lego-text-field
          ref="widgetName"
          :rules="validator.widgetName"
          :modelValue="widgetName"
          counter="100"
          showCounter
          :guide="$t('hint.common') + ' ' + $t('hint.notStartWithDot')"
          @update:modelValue="(value) => changeWidgetName(value)"
          isFreeText
        />
      </div>
      <BoxRegion class="area" />
    </div>
  </div>
</template>
<script>
import configMixin from './configMixin';
import validateFieldsMixin from '@/mixins/validateFields.mixin';

export default {
  mixins: [configMixin, validateFieldsMixin],
  emits: ['update:changeField'],
  data() {
    return {
      isChanged: false,
      widgetName: '', // 위젯명
      defaultConfig: this.config({
        // 이벤트맵 위젯 기본 설정
        title: this.$t('title.eventMap'),
        isResizable: true,
        h: 4,
        minW: 2,
        maxW: 8,
        minH: 2,
        maxH: 6,
        widget: {
          type: 'EventMapWidget',
          api: '/cloudmonitorings/event/v1/console/events/latest',
          options: {}
        }
      }),
      validator: {
        widgetName: [this.checkWidgetName]
      },
      validateFieldKey: 'eventMapWidgetConfig'
    };
  },
  mounted() {
    this.setFieldsBeforeModify();
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  methods: {
    validate() {
      return this.$util.validate([this.$refs.widgetName]);
    },
    // 위젯 설정정보 update
    onConfigChange(isApiCall = true) {
      let configs = [];
      let config = this.getCommonConfig();
      config.chartAttr.title = this.widgetName;
      config.isApiCall = isApiCall;
      configs.push(config);

      this.checkCount++;
      if (this.checkCount === 1) this.originConfigs = configs;

      this.$emit('configModify', configs);
    }
  }
};
</script>
<style lang="scss" scoped>
.area {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 8px;
  }
}

.content-wrapper {
  margin-top: 24px;
}
</style>
